import React, { useEffect, useState } from 'react';
import { fetchCollection } from '../../../api/common';
import { fetchLeaveSummary, postLeaveRequest } from './api';
import QuarterlyLeaveModal from './QuarterlyLeaveModal';
import { formatLongDate, getCurrentQuarter } from '../../../utils/dateFormat';
import { safeApiCall } from '../../../utils/apiHelpers';

const LeaveSummary = () => {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [applyOpen, setApplyOpen] = useState(false);
  const [collection, setCollection] = useState(null);
  const [collectionLoading, setCollectionLoading] = useState(false);
  const [error, setError] = useState(null);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
  // Modal state for quarterly view
  const [quarterModal, setQuarterModal] = useState({ open: false, leaveType: '', quarters: [] });

  // Define currentQuarter dynamically
  const currentQuarter = getCurrentQuarter();
  const year = selectedYear;

  useEffect(() => {
    setLoading(true);
    safeApiCall(fetchLeaveSummary, selectedYear)
      .then(data => {
        setSummary(data);
        setError(null);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [selectedYear]);

  const handleApplyClick = async () => {
    setCollectionLoading(true);
    try {
      const data = await safeApiCall(fetchCollection, ['leave_types', 'leave_day_type', 'holidays']);
      setCollection(data);
      setApplyOpen(true);
    } finally {
      setCollectionLoading(false);
    }
  };

  // New handler for leave submit (like TeamLeaveRequests)
  const handleApplyLeave = async (payload) => {
    setCollectionLoading(true);
    try {
      await safeApiCall(postLeaveRequest, payload);
      setApplyOpen(false);
      setLoading(true);
      const data = await safeApiCall(fetchLeaveSummary, selectedYear);
      setSummary(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setCollectionLoading(false);
      setLoading(false);
    }
  };


  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold">Q{currentQuarter} Leave Summary in {selectedYear}</h2>
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium">Select Year:</label>
          <select
            className="border rounded px-2 py-1"
            value={selectedYear}
            onChange={e => setSelectedYear(Number(e.target.value))}
          >
            {years.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
          {/* <button
            className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 ml-4"
            onClick={handleApplyClick}
            disabled={collectionLoading}
          >
            Apply Leave
          </button> */}
        </div>
      </div>
      {loading ? (
        <div>Loading leave summary...</div>
      ) : error ? (
        <div className="text-red-500">{error}</div>
      ) : (
        <>
          {/* Quarter summary cards */}
          <div className="flex gap-4 mb-6">
            {summary.map(leave => {
              const q = leave.quarters.find(q => q.quarter === currentQuarter);
              return (
                <div key={leave.leave_type} className="bg-white rounded shadow p-4 flex-1 text-center">
                  <div className="font-bold mb-1">{leave.leave_type}</div>
                  <div className={`text-2xl font-bold ${q && q.remaining < 0 ? 'text-red-600' : 'text-green-600'}`}>{q ? q.remaining : '-'}
                    <span className="text-base font-normal ml-1">Available</span>
                  </div>
                  <div className="text-sm text-gray-500 mt-1">
                    <span className="text-red-500 font-bold">{q ? q.taken : '-'}</span> Booked
                  </div>
                </div>
              );
            })}
          </div>
          {/* Year summary */}
          <div className="mb-2">Overall Leave Summary for {year}</div>
          <div className="flex gap-4">
            {summary.map(leave => (
              <div key={leave.leave_type} className="bg-white rounded shadow p-4 flex-1">
                <div className="font-bold mb-1">{leave.leave_type}</div>
                <div className="text-sm">
                  Total Taken: <span className="font-bold text-red-500">{leave.yearly.taken}</span>
                </div>
                <div className="text-sm">
                  Remaining in Year: <span className={`font-bold ${leave.yearly.remaining < 0 ? 'text-red-600' : 'text-green-600'}`}>{leave.yearly.remaining}</span>
                </div>
                <div
                  className="text-xs mt-1 text-blue-700 underline cursor-pointer"
                  onClick={() => setQuarterModal({ open: true, leaveType: leave.leave_type, quarters: leave.quarters })}
                >
                  (Click here for Detail View)
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      {/* Apply Leave Modal */}
      {/* {applyOpen && collection && (
        <ApplyLeaveModal
          open={applyOpen}
          onClose={() => setApplyOpen(false)}
          onSubmit={handleApplyLeave}
          collection={collection}
          reportingManagerId={null} // Set if available
        />
      )} */}
      {/* Quarterly Leave Modal */}
      {quarterModal.open && (
        <QuarterlyLeaveModal
          open={quarterModal.open}
          onClose={() => setQuarterModal({ ...quarterModal, open: false })}
          leaveType={quarterModal.leaveType}
          quarters={quarterModal.quarters}
        />
      )}
    </div>
  );
};

export default LeaveSummary;
